import React, { CSSProperties } from 'react'
import { useFetchCaseStudies } from '@/hooks/useFetchCaseStudies'
import { Grid } from '@/components/organisms/SectionCaseStudiesGrid/Grid/Grid'
import { CaseStudiesGridProps } from '@/components/organisms/SectionCaseStudiesGrid/types'

export function SectionCaseStudiesGrid({ industry_label, items_per_page = '9' }: CaseStudiesGridProps) {
  const { loading, error, data } = useFetchCaseStudies()

  return (
    <section id="grid" className="max-w-screen-desktop mx-auto px-24 netbook:px-90 pb-48 netbook:pb-96 netbook:pt-0">
      {error && <div>Error: {error.message}</div>}
      {loading ? (
        <div
          style={{ '--itemsCount': +items_per_page } as CSSProperties}
          className="h-[calc(var(--itemsCount)*322px)] netbook:h-[calc((var(--itemsCount)*416px)/3)] grid place-content-center"
        >
          Loading...
        </div>
      ) : (
        <Grid items={data} industry_label={industry_label} items_per_page={items_per_page} />
      )}
    </section>
  )
}
